// extracted by mini-css-extract-plugin
export default {"icon":"skillicon-module--icon--e+NxN","img":"skillicon-module--img--NlekF"};